<template>
  <section>


  <div class="top__container">
    <div class="wrapper__texts">
        <div class="low__text" data-animate="slideUp">{{ fields['Title section'] }}</div>
        <div class="text" data-animate="slideUp">{{ fields['Text section'] }}</div>
        <router-link :to="{ name: 'products' }">
          {{ fields['Text button'] }} 
          <svg width="15.000000" height="10.000000" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs/>
              <path id="Union" d="M12.74 4.42L9.02 0.81L9.86 0L14.58 4.59L15 5L14.58 5.4L9.86 10L9.02 9.18L12.74 5.57L0 5.57L0 4.42L12.74 4.42Z" fill="#050505" fill-opacity="1.000000" fill-rule="evenodd"/>
          </svg>
        </router-link>
    </div>
  </div>

  
      <div class="image-section">
        <img v-simple-parallax="{ scale: 1.1,delay: 0.4 }" :src="`${this.$store.state.base_directory}${fields['Image'].replace(/^public\//, '')}`" alt="Factory image" class="factory-image" />
      </div>
      <div class="top__container">
        <div class="details" data-animate-group>
          <div class="detail-item" v-for="item in fields['Repeater']" data-animate="slideUp">
            <div class="icon">
              <img :src="`${this.$store.state.base_directory}${item.image.replace(/^public\//, '')}`" alt="Изображение">
            </div>
            <div class="text" v-html="item.text">
            </div>
          </div>
        </div>
    </div>
  </section>
  </template>
  
  <script>
    export default {
      name: "ServicesSection",

      props: {
          fields: [Array,Object],
      },

  };
  </script>
  
<style>
  .image-section {
    padding-top: 45%;
    position: relative;
    overflow: hidden;
    margin-bottom: 64px;
  }
  .factory-image {
    max-width: 100%;
    max-height: 100%;
    display: block;
    object-fit: cover; /* или contain, если не нужно обрезание */
  }
  .image-section .simpleParallax{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .wrapper__texts{
      position: relative;
      margin-bottom: 36px;
  }
  .wrapper__texts .low__text{
      color: rgb(85, 98, 114);
      font-size: 13px;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: 0%;
      text-align: left;
      padding-bottom: 10px;
  }
  .wrapper__texts .text{
  /* Header/H1: 44px Medium */
      color: rgb(5, 5, 5);
      font-size: 44px;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: 0%;
      text-align: left;
      max-width: 640px;
  }
  .wrapper__texts a{
      position: absolute;
      bottom: 0;
      right: 0;
      display: flex;
      align-items: center;
      gap: 8px;
      color: rgb(5, 5, 5);
      font-size: 16px;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: 0%;
      text-align: left;
  }
  .services-container {
    font-family: Arial, sans-serif;
    padding: 20px;
    color: #333;
  }
  
  .header {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .header span {
    text-transform: uppercase;
    font-size: 14px;
    color: #777;
  }
  
  .header h1 {
    font-size: 28px;
    margin: 10px 0;
    color: #000;
  }
  
  .learn-more {
    font-size: 14px;
    color: #007bff;
    text-decoration: none;
  }
  
  .learn-more:hover {
    text-decoration: underline;
  }
  
  .factory-image {
    width: 100%;
    height: 100%;
  }
  
  .details {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
  
  .detail-item {
    flex: 1 1 calc(50% - 20px);
    display: flex;
    flex-direction: column;
  }
  
  .icon {
    flex-shrink: 0;
    width: 56px;
    height: 56px;
    background: linear-gradient(180.00deg, rgb(173, 184, 199),rgb(222, 230, 234) 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
  }
  .text p{
    color: rgb(5, 5, 5);
    font-size: 24px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    padding-bottom: 28px;
    border-bottom: 1px solid rgb(222, 230, 234);
  }
  .text p:last-of-type:not(:only-of-type) {
    padding-top: 32px;
    border-bottom: unset;
    padding-bottom: unset;
  }
  @media (max-width: 1024px) {
    .wrapper__texts a{
        bottom: unset;
        top: 0;
    }
    .wrapper__texts .text{
        font-size: 44px;
        max-width: 100%;
    }
    .image-section{
      height: 100%;
    }
    .wrapper__texts .text{
      font-size: 32px;
    }
}
  /* Адаптивность */
  @media (max-width: 768px) {
    .details {
      flex-direction: column;
    }
  
    .detail-item {
      flex: 1 1 100%;
      flex-direction: row;
      gap: 12px;
    }
  
    .header h1 {
      font-size: 24px;
    }
    .wrapper__texts .text{
      font-size: 24px;
    }
    .learn-more {
      font-size: 12px;
    }
    .text p{
      font-size: 14px;
      padding-bottom: 16px;
      border-bottom: unset;
    }
    .text p:first-of-type:not(:only-of-type) {
      border-bottom: 1px solid rgb(222, 230, 234);
    }
    .text p:last-of-type:not(:only-of-type) {
    padding-top: 16px;
    border-bottom: unset;
    padding-bottom: unset;
  }
  }
</style>